/**
 *  【系统右上角的个人设置】
 * */
import React from 'react';
import PropTypes from 'prop-types';
import Main from './pages/main';

const Setting = ({ history, match }) => {
    return <Main history={history} match={match} />;
};

Setting.propTypes = {
    history: PropTypes.object,
    match: PropTypes.object,
};

export default Setting;